import { InMemoryDbService, RequestInfo } from 'angular-in-memory-web-api';
import { Injectable, inject } from '@angular/core';
import { InMemoryHttpClientFactoryService } from './in-memory-http-client/in-memory-http-client-factory.service';

/**
 * This service intercepts Angular HTTP requests and redirects them to an in-memory data store.
 */
@Injectable({
  providedIn: 'root',
})
export class InMemoryDataService implements InMemoryDbService {
  private inMemoryHttpClientFactoryService = inject(InMemoryHttpClientFactoryService);


  /**
   * Intercepts POST HTTP request.
   * @param reqInfo information about the current POST request.
   */
  post(reqInfo: RequestInfo) {
    return this.inMemoryHttpClientFactoryService.getInMemoryHttpClient(reqInfo.collectionName).post(reqInfo);
  }

  /**
   * Intercepts GET HTTP request.
   * @param reqInfo information about the current GET request.
   */
  get(reqInfo: RequestInfo) {
    return this.inMemoryHttpClientFactoryService.getInMemoryHttpClient(reqInfo.collectionName).get(reqInfo);
  }

  /**
   * Intercepts PUT HTTP request.
   * @param reqInfo information about the current PUT request.
   */
  put(reqInfo: RequestInfo) {
    return this.inMemoryHttpClientFactoryService.getInMemoryHttpClient(reqInfo.collectionName).put(reqInfo);
  }

  /**
   * Intercepts PATCH HTTP request.
   * @param reqInfo information about the current PATCH request.
   */
  patch(reqInfo: RequestInfo) {
    return this.inMemoryHttpClientFactoryService.getInMemoryHttpClient(reqInfo.collectionName).patch(reqInfo);
  }

  /**
   * Intercepts DELETE HTTP request.
   * @param reqInfo information about the current DELETE request.
   */
  delete(reqInfo: RequestInfo) {
    return this.inMemoryHttpClientFactoryService.getInMemoryHttpClient(reqInfo.collectionName).delete(reqInfo);
  }

  /**
   * Creates an in-memory database.
   * @param reqInfo information about the currect request.
   */
  createDb(reqInfo?: RequestInfo) {
    return {};
  }
}
